<template>
  <div v-cloak>
    <div v-if="zone>0 && hrConnected==0">
      <div v-if="zoneRange == 'low'" class="zone flex justify-content-center flex-vertical">
        <span class="symbol">&#8679;</span>
        <span class="h3">Increase Speed / Load</span>
      </div>
      <div v-else-if="zoneRange == 'high'" class="zone flex justify-content-center flex-vertical">
        <span class="symbol">&#8681;</span>
        <span class="h3">Decrease Speed / Load</span>
      </div>
      <div v-else class="zone flex justify-content-center flex-vertical">
        <span class="symbol">&#10003;</span>
      </div>
    </div>
    <div v-else>
      <div v-if="state == 'low'" class="zone flex justify-content-center flex-vertical">
        <span class="symbol">&#8679;</span>
        <span class="h3">Increase Speed / Load</span>
      </div>
      <div v-else-if="state == 'high'" class="zone flex justify-content-center flex-vertical">
        <span class="symbol">&#8681;</span>
        <span class="h3">Decrease Speed / Load</span>
      </div>
      <div v-else class="zone flex justify-content-center flex-vertical">
        <span class="symbol">&#10003;</span>
      </div>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'feedback',
    
    props: {
      heartRateZone:Number,
      zone:Number,
      hrConnected:Number,
    },
    data() {
      return {
        state:"low",
      }
    },
    methods: {
    },
    computed: {
      zoneRange() {
        if (this.heartRateZone < this.zone) 
          return "low";
        else if (this.heartRateZone > this.zone)
          return "high";
        else return "";
      },
    },
    watch: {
      zone(newValue, oldValue) {
        if (this.hrConnected != 0) {
          if (newValue < oldValue) {
            this.state = "high";
          }
          else if (newValue > oldValue) {
            this.state = "low";
          }
          else {
            this.state = "";
          }

          setTimeout(()=> {
            this.state = "";
          },15000);
        }
      }
    },
    mounted() {
      setTimeout(()=> {
        this.state = "";
      },15000);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .symbol {
    color:white;
    font-size:14vw;
    line-height: 14vw;
    padding-top:4vw;
  }

</style>
